module.exports = "/*hide scrolbars in ie*/\n\niframe{\n  overflow:hidden;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile-map/profile-map.component.css
// module id = ./src/app/profile-map/profile-map.component.css
// module chunks = main